import React from 'react';
import { useStars } from '../context/StarsContext';
import './StarButton.css';

interface StarButtonProps {
  itemId: string;
  itemType: 'skill' | 'mcp-server';
}

export default function StarButton({ itemId, itemType }: StarButtonProps) {
  const { counts, userStars, toggle, pendingItems } = useStars();
  const starred = userStars.has(itemId);
  const count = counts[itemId] ?? 0;
  const pending = pendingItems.has(itemId);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    toggle(itemId, itemType);
  };

  return (
    <button
      type="button"
      className={`star-btn${starred ? ' star-btn--starred' : ''}`}
      onClick={handleClick}
      disabled={pending}
      aria-label={starred ? 'Unstar' : 'Star'}
    >
      {starred ? (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"/>
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2">
          <path d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"/>
        </svg>
      )}
      <span className="star-btn-count">{count}</span>
    </button>
  );
}
